import type { StyleSystemProps } from '@withjoy/joykit';
import { ButtonV2, styled, TextV1 } from '@withjoy/joykit';
import type { ButtonOverrides } from '@withjoy/joykit/components/ButtonV2/Button.types';

export const StyledTitleText = styled(TextV1)`
  overflow: hidden;
`;

export const priceStyles = (isDisabled: boolean): StyleSystemProps => ({
  marginRight: 3,
  textDecoration: isDisabled ? 'line-through' : 'unset',
});

export const StyledBrandButton = styled(ButtonV2)`
  text-decoration: underline;
  text-decoration-color: ${props => props.theme.colors.mono5};
  &:hover {
    text-decoration-color: ${props => props.theme.colors.mono8};
  }
  &:active {
    text-decoration-color: ${props => props.theme.colors.mono14};
  }
`;

export const brandButtonOverrides: ButtonOverrides = {
  Root: {
    props: {
      color: 'mon14',
      _hover: {
        color: 'mono12',
      },
      _active: {
        color: 'mono14',
      },
    },
  },
};

export const styles = {
  price: priceStyles,
};
